import { trustItems } from '@/mocks/siteData';

export default function TrustBar() {
  return (
    <section className="py-8 md:py-10 bg-background-50 border-b border-background-200/60">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {trustItems.map((item) => (
            <div key={item} className="flex items-center gap-2">
              <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-primary-500 text-xs"></i>
              </div>
              <span className="text-sm font-medium text-foreground-600 whitespace-nowrap">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}